import authReducer from "./auth";
import { combineReducers } from "redux";

const allReducer = combineReducers({
  auth: authReducer,
});

export default allReducer;
